<template lang="pug">
  section.d-flex.align-center.black(style="width: 100%;")
    section.mx-4(style="width: 40px; height: 40px;")
      router-link(to="/")
        v-img(src="/img/ato-logo.svg")

    section.d-flex.flex-grow-1.align-center
      v-btn.mr-0(
        dense
        text
        :ripple="false" 
      )
        span {{currentPath}}
      LinkPinner
</template>

<script>
import LinkPinner from "@/components/tools/LinkPinner";
export default {
  components: { LinkPinner },
  computed: {
    menuItems() {
      const isRestrictedCurator = this.$store.getters.isCurator && !this.$store.getters.isCore
      return [
        { link: "/me", name: "Mein Profil", visible: this.$store.getters.isCore },
        { link: "/magazine", name: "Magazin", visible: (this.$store.getters.isCore || this.$store.getters.isEditor) && !isRestrictedCurator },
        { link: "/logbuch", name: "Logbuch", visible: this.$store.getters.isCore },
      ]
    },
    currentPath () {
      try{
        switch (this.$route.name.toLowerCase()) {
          case 'me':
            return 'deine Seite, ' + this.$store.getters.user.name
            break;
          case 'index':
            return 'Startseite'
            break;

          case 'artists':
            return 'Künstler*innen'
            break;
          case 'artist-slug':
            return 'Künstler*in - ' +  this.$route.params.slug
            break;
        
          case 'artworks':
            return 'Kunstwerke'
            break;

          case 'artwork-slug':
            return 'Kunstwerk - ' +  this.$route.params.slug
            break;

          case 'exhibitions':
            return 'Ausstellungen / Events '
            break;
        
          case 'magazine':
            return 'Magazin'
            break;
        
          default:
            break;
        }
        return this.$route.name
      }catch(err){
        return "Super Route!"
      }
    }
  }
}
</script>
